import formFieldDistancia from "./formFieldDistancia";

const { descricao, distancia, unidade, qtdLimite, incluiCamiseta } =
  formFieldDistancia;

const initialValuesCategoria = {
  [descricao.name]: "",
  [distancia.name]: "",
  [unidade.name]: "",
  [qtdLimite.name]: "",
  [incluiCamiseta.name]: true,
};

const initialValuesEditCategoria = (data: any) => {
  return {
    [descricao.name]: data.descricao || "",
    [distancia.name]: data.distancia || null,
    [unidade.name]: data.unidade || null,
    [qtdLimite.name]: data.qtdLimite || null,
    [incluiCamiseta.name]: data.incluiCamiseta !== false,
  };
};

export { initialValuesCategoria, initialValuesEditCategoria };
